import React from "react";

const commonStyle = {
  height: "100%",
  background: "#44546b",
  // display: "block",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        ...commonStyle,
        left: "-20px",
      }}
      onClick={onClick}
    >
      <div
        style={{
          width: "0",
          height: "0",
          borderTop: "20px solid transparent",
          borderBottom: "20px solid transparent",
          borderRight: "20px solid #fff",
        }}
      ></div>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        ...commonStyle,
        right: "-20px",
      }}
      onClick={onClick}
    >
      <div
        style={{
          width: "0",
          height: "0",
          borderTop: "20px solid transparent",
          borderBottom: "20px solid transparent",
          borderLeft: "20px solid #fff",
        }}
      ></div>
    </div>
  );
};

const SliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  draggable: false,

  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default SliderSettings;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/common/sliderSettings.js